<h4>{{ create ? 'Create' : 'Edit' }} institution</h4>
<mat-dialog-content>
	<atomic-institution-badge
		*ngIf="majorBank"
		[institution]="institutionBadgeDetails"
	></atomic-institution-badge>

	<form
		[formGroup]="form"
		novalidate
		*ngIf="!majorBank"
		class="grid grid-cols-2 gap-2"
	>
		<app-input
			label="Institution name"
			name="name"
			[required]="true"
			formControlName="name"
			[submitted]="submitted"
		>
		</app-input>
		<app-input
			*ngIf="showInstNumber"
			[required]="true"
			label="Institution number"
			name="institutionNumber"
			formControlName="institutionNumber"
			type="text"
			[submitted]="submitted"
			appDigitsOnly
		>
		</app-input>
		<app-address
			name="Institution address"
			formControlName="address"
			[required]="true"
			[submitted]="submitted"
			[showCareOf]="true"
			[enableCountrySelect]="false"
			class="col-span-2"
		>
		</app-address>
		<app-dropdown
			[required]="true"
			[submitted]="submitted"
			formControlName="type"
			label="Financial institution type"
			name="financialInstitutionType"
			(onSelect)="onFinancialInstitutionTypeSelect($event)"
			[itemGroups]="[{ items: financialInstitutionTypesDropdownOptions }]"
			class="col-span-2"
		>
		</app-dropdown>
	</form>

	<ng-container>
		<div class="flex mt-6 px-1">
			<div class="font-bold">
				<h4 *ngIf="!showDischargeFields">Contact details</h4>
				<h4 *ngIf="showDischargeFields">Payout/discharge contact</h4>
			</div>
		</div>

		<div class="px-1">
			<form [formGroup]="form" novalidate>
				<ng-container *ngIf="!showDischargeFields">
					<app-contact-info-form [group]="form"> </app-contact-info-form>
				</ng-container>
				<ng-container *ngIf="showDischargeFields">
					<app-contact-info-form
						[group]="form.controls.discharge.controls.primary"
					>
					</app-contact-info-form>
					<app-container
						title="Escalation"
						size="small"
						class="flex-col mt-6 container--dark"
						[collapsable]="true"
						[collapsed]="true"
					>
						<app-contact-info-form
							[group]="form.controls.discharge.controls.escalation"
						>
						</app-contact-info-form>
					</app-container>
				</ng-container>
			</form>
		</div>
	</ng-container>
</mat-dialog-content>
<mat-dialog-actions class="flex justify-between">
	<app-button type="button" btn="border" mat-dialog-close>Cancel</app-button>
	<app-button (click)="onSubmit()" [disabled]="form?.invalid">
		{{ create ? 'Create' : 'Save' }}
	</app-button>
</mat-dialog-actions>
